var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "no-stroke",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7914 1.09816C10.8858 1.26504 10.827 1.4768 10.6601 1.57114L5.78115 4.32925C5.61427 4.42359 5.40251 4.36478 5.30817 4.1979C5.21383 4.03102 5.27264 3.81926 5.43952 3.72492L10.3184 0.966813C10.4853 0.872474 10.6971 0.93128 10.7914 1.09816Z",
    fill: "#6D819C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "no-stroke",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12318 0.0406143C8.28818 0.0406143 8.42195 0.174377 8.42195 0.339383L8.42195 5.16349C8.42195 5.32849 8.28818 5.46226 8.12318 5.46226C7.95817 5.46226 7.82441 5.32849 7.82441 5.16349L7.82441 0.339382C7.82441 0.174377 7.95817 0.0406144 8.12318 0.0406143Z",
    fill: "#6D819C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "no-stroke",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12326 1.33468C8.28827 1.33468 8.42203 1.46844 8.42203 1.63344L8.42203 6.45755C8.42203 6.62256 8.28827 6.75632 8.12326 6.75632C7.95826 6.75632 7.8245 6.62256 7.8245 6.45755L7.8245 1.63344C7.8245 1.46844 7.95826 1.33468 8.12326 1.33468Z",
    fill: "#6D819C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "no-stroke",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35266 1.23048C5.44101 1.06496 5.64681 1.0024 5.81234 1.09075L10.6515 3.67378C10.8171 3.76214 10.8796 3.96794 10.7913 4.13346C10.7029 4.29898 10.4971 4.36154 10.3316 4.27319L5.49239 1.69016C5.32687 1.6018 5.26431 1.396 5.35266 1.23048Z",
    fill: "#6D819C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "no-stroke",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09621 7.09321C5.80721 7.09321 3.95161 8.94881 3.95161 11.2378C3.95161 13.5268 5.80721 15.3824 8.09621 15.3824C10.3852 15.3824 12.2408 13.5268 12.2408 11.2378C12.2408 8.94881 10.3852 7.09321 8.09621 7.09321ZM3.33301 11.2378C3.33301 8.60717 5.46557 6.47461 8.09621 6.47461C10.7269 6.47461 12.8594 8.60717 12.8594 11.2378C12.8594 13.8685 10.7269 16.001 8.09621 16.001C5.46557 16.001 3.33301 13.8685 3.33301 11.2378Z",
    fill: "#6D819C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOther);
export default __webpack_public_path__ + "static/media/ic-other.02e7cbb69653406307747da20e188ffe.svg";
export { ForwardRef as ReactComponent };